export const LANGS = ["en", "uk", "ru", "bg"];

const SUPPORTED = new Set(LANGS);

function normalizeLang(raw) {
  if (typeof raw !== "string") return null;
  const base = raw.trim().toLowerCase().split(/[-_]/)[0];
  if (!base || !SUPPORTED.has(base)) return null;
  return base;
}

function firstSegment(pathname) {
  if (typeof pathname !== "string") return null;
  const [segment] = pathname.replace(/^\/+/, "").split("/");
  return segment || null;
}

// Rest of the path after the language segment, so a future route survives a
// language switch instead of being thrown away with it.
function pathTail(pathname) {
  if (typeof pathname !== "string") return "";
  const stripped = pathname.replace(/^\/+/, "");
  const slash = stripped.indexOf("/");
  if (normalizeLang(firstSegment(pathname))) {
    const tail = slash === -1 ? "" : stripped.slice(slash);
    return tail === "/" ? "" : tail;
  }
  return stripped ? `/${stripped}` : "";
}

// The path owns the language. ?lang= is still read because links shared before
// this change carry it, but it is never written back - two places holding the
// same fact is how a stale one wins on the next reload.
export function resolveLang(pathname, search, navigatorLanguage) {
  const fromPath = normalizeLang(firstSegment(pathname));
  if (fromPath) return fromPath;

  if (typeof search === "string" && search.length > 0) {
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    const fromQuery = normalizeLang(params.get("lang"));
    if (fromQuery) return fromQuery;
  }

  return normalizeLang(navigatorLanguage) || "en";
}

// Address for a language: /<lang> plus whatever followed it, with the legacy
// lang parameter dropped so the query cannot contradict the path.
export function langUrl(pathname, search, hash, lang) {
  const code = SUPPORTED.has(lang) ? lang : "en";
  const raw = typeof search === "string" ? search : "";
  const params = new URLSearchParams(raw.startsWith("?") ? raw.slice(1) : raw);
  params.delete("lang");
  const query = params.toString();
  const rest = pathTail(pathname);
  return `/${code}${rest}${query ? `?${query}` : ""}${typeof hash === "string" ? hash : ""}`;
}
